// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._4t3i1wug{height:auto}\n._p12f1osq{max-width:100%}", ""]);
// Exports
module.exports = exports;
